import { createMiddleware } from '@shared/redux';
import { showErrorToast } from '@shared/toasts/toasts.state';
import {
    GET_STRIPE_CUSTOMER_REQUEST_FAILED,
    UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED,
    CREATE_STRIPE_CUSTOMER_REQUEST_FAILED,
    HANDLE_SUBMIT_STRIPE_CUSTOMER,
    getStripeCustomerData,
    updateStripeCustomerRequest,
    createStripeCustomerRequest,
} from './stripe-customer.state';
import { STRIPE_CUSTOMER_TEXTS } from './stripe-customer.constants';

export const stripeCustomerMiddleware = createMiddleware({
    [GET_STRIPE_CUSTOMER_REQUEST_FAILED]: (_, action) => {
        const statusCode = action.payload.response.status;
        const notFound = 404;

        if (statusCode === notFound) return [];

        return showErrorToast({
            message: 'There was an error getting your payment information. Try again in a few seconds.',
        });
    },
    [HANDLE_SUBMIT_STRIPE_CUSTOMER]: (state, action) => {
        const { paymentMethodId } = action.payload;
        const stripeCustomer = getStripeCustomerData(state);

        const data = { paymentMethodId };
        const stripeCustomerId = stripeCustomer?.id;

        if (stripeCustomerId) {
            return updateStripeCustomerRequest({
                stripeCustomerId,
                data,
            });
        }

        return [createStripeCustomerRequest(data)];
    },
    [CREATE_STRIPE_CUSTOMER_REQUEST_FAILED]: () => [
        showErrorToast({ message: STRIPE_CUSTOMER_TEXTS.CREATE_OR_UPDATE_STRIPE_CUSTOMER_FAILED })],
    [UPDATE_STRIPE_CUSTOMER_REQUEST_FAILED]: () => [
        showErrorToast({ message: STRIPE_CUSTOMER_TEXTS.CREATE_OR_UPDATE_STRIPE_CUSTOMER_FAILED })],
});
